module.exports = __webpack_public_path__ + "img/protective_gear4.9ad5bb3d.png";